import { useForm } from 'react-hook-form';
import { formResolver } from 'src/utils/formResolver';
import { buildConfigurationValidationSchema } from 'src/pages/ConfigurationPage/utils/buildConfigurationValidationSchema';
import type { ConfigurationFormFieldsObject } from 'src/pages/ConfigurationPage/hooks/useConfigurationFormFields';
import {
  getPersonaFormValues,
  type PersonaFormValues,
  type PersonaInputData,
} from 'src/pages/ConfigurationPage/utils/getPersonaFormValues';

// Owns the persona/system-prompt react-hook-form instance: initial values
// sourced from the active version's input data, and a validation schema that
// stays in sync with the active version's required-field configuration.

export interface ConfigurationFormValues extends PersonaFormValues {
  pf_words_blacklist_item?: string;
  // The role option last clicked; opens the sales role popup, never submitted.
  pf_role_click_value?: string;
  text: string;
  // System-prompt tab fields; they are set with setValue rather than given defaults.
  // The selected custom template's id as a string, or 'custom'.
  template_id?: string;
  selected_template_id?: string | number;
  placeholder?: string;
}

export type ConfigurationFormMethods = ReturnType<typeof useConfigurationForm>;

export const useConfigurationForm = ({
  inputData,
  formFieldsObject,
  systemPromptActive,
}: {
  inputData: PersonaInputData | null;
  formFieldsObject: ConfigurationFormFieldsObject;
  systemPromptActive: boolean;
}) => {
  return useForm<ConfigurationFormValues>({
    defaultValues: {
      ...getPersonaFormValues(inputData, formFieldsObject),
      text: '',
    },
    resolver: formResolver(
      buildConfigurationValidationSchema(formFieldsObject, systemPromptActive),
    ),
  });
};
